import SpotlightItem from '../store/schema/SpotlightItem';
import SpotlightReason from '../store/schema/SpotlightReason';
import { getRowKeysFromRowIds, TableView } from 'owa-mail-list-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

export default async function processSpotlightItemsResponse(
    response: Response,
    inboxTableView: TableView
): Promise<SpotlightItem[]> {
    const spotlightItems: SpotlightItem[] = [];
    const processedConversations = [];

    const spotlightResponse = await response.json();
    const rawSpotlightItems = spotlightResponse?.EntitySets?.[0]?.ResultSets?.[0]?.Results || [];

    const isConversationView =
        inboxTableView.tableQuery.listViewType === ReactListViewType.Conversation;

    for (let i = 0; i < rawSpotlightItems.length; i++) {
        const result = rawSpotlightItems[i].Source;

        const conversationId = result.ConversationId?.Id;
        const itemId = result.ItemId?.Id;

        /**
         * Because we don't have conversation support from the Spotlight API,
         * we dedupe any conversations that appear in the list of Spotlight
         * items multiple times.
         */
        if (isConversationView) {
            if (processedConversations.indexOf(conversationId) > -1) {
                continue;
            } else {
                processedConversations.push(conversationId);
            }
        }

        const rowId = isConversationView ? conversationId : itemId;
        const rowKeys = getRowKeysFromRowIds([rowId], inboxTableView);

        // Skip item if it's not found in the inbox.
        if (rowKeys.length === 0) {
            continue;
        }

        spotlightItems.push({
            conversationId: conversationId,
            itemId: itemId,
            rowKey: rowKeys[0],
            isUnseen: spotlightItems.length < 2, // TODO: Remove when isUnseen is an actual property in response
            reason: SpotlightReason.None,
            senderName: result.Sender?.EmailAddress?.Name,
        });
    }

    return spotlightItems;
}
